import { combineReducers } from "redux";
import errorReducer from "./error-reducer";
import dncDataReducer from "./dnc-reducer";
export default combineReducers({
	error: errorReducer,
	dncData: dncDataReducer
});
